module.exports = __webpack_public_path__ + "img/11_27.3a530300.png";